/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  CreateLabelResponseData,
  CreateLabelResponseDataFromJSON,
  CreateLabelResponseDataFromJSONTyped,
  CreateLabelResponseDataToJSON
} from './CreateLabelResponseData'

/**
 *
 * @export
 * @interface CreateLabelResponse
 */
export interface CreateLabelResponse {
  /**
   *
   * @type {number}
   * @memberof CreateLabelResponse
   */
  status?: number
  /**
   *
   * @type {CreateLabelResponseData}
   * @memberof CreateLabelResponse
   */
  data?: CreateLabelResponseData
}

export function CreateLabelResponseFromJSON(json: any): CreateLabelResponse {
  return CreateLabelResponseFromJSONTyped(json, false)
}

export function CreateLabelResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLabelResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : CreateLabelResponseDataFromJSON(json['data'])
  }
}

export function CreateLabelResponseToJSON(value?: CreateLabelResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: CreateLabelResponseDataToJSON(value.data)
  }
}
